







































import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import PhaseAliasesGrid from '../components/phase-aliases/phase-aliases-grid.vue';
import PhaseAliasesEdit from '../components/phase-aliases/phase-aliases-edit.vue';
import { PhaseAliasDto } from '../models/PhaseAliasDto';
import { DxPopup, DxButton } from 'devextreme-vue';
import _ from "lodash";

@Component({
  components: {
    PageTitle,
    PhaseAliasesGrid,
    PhaseAliasesEdit,
    DxPopup,
    DxButton
  }
})
export default class PhaseAliases extends Vue {
$refs: Vue['$refs'] & {   
  dataGrid?: PhaseAliasesGrid;
} = {};

  phaseAlias: PhaseAliasDto;
  showingEdit: boolean = false;
  deleteVisible: boolean = false;

  constructor() {
    super();
    this.phaseAlias = new PhaseAliasDto();
  }
  

  refreshDataGrid(): void {  
    if (this.$refs.dataGrid) {
      (this.$refs.dataGrid as any).refreshDataGrid();
    }
  }

  hidingDialog(): void {
    this.phaseAlias = new PhaseAliasDto();
    this.showingEdit = false;    
    this.refreshDataGrid();
  }

  showDialog(data: any): void {
    this.phaseAlias = data ? _.cloneDeep(data) : new PhaseAliasDto();
    this.showingEdit = true;
  }

  showDelete(data: any): void {
    this.phaseAlias = _.cloneDeep(data);
    this.deleteVisible = true;    
  }

  deleteAlias(): void {
    (this.$refs.dataGrid as any).deleteAlias(this.phaseAlias);
    this.phaseAlias = new PhaseAliasDto();
    this.hideDelete();
  }

  hideDelete(): void {
    this.deleteVisible = false;
    this.phaseAlias = new PhaseAliasDto();
  }
}
